module.exports = __webpack_public_path__ + "static/media/sponsor_group1.4753472f.png";